import { getCookie } from '../helpers/Cookies';

class AuthHelper {
    static getAuthToken() {
        // TODO: Need to extend this further to return a config object with V5 version and Auth token, when all the API resource required Authtoken.
        return getCookie('AuthToken');
    }
}

export default AuthHelper;
